import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppConfigService } from "src/app/app-config.service";
import { CommonService } from "../../../common-service";
import { GetDeviceResponse } from "../../../responses/device/get-device.response";
import { ListDeviceResponse } from "../../../responses/device/list-device.response";
import { ApiEnum } from "src/app/shared/enum/api.enum";
import { EndpointBuilderService } from "../../../endpint-builder.service";


@Injectable({
  providedIn: 'root'
})
export class DeviceVisualizationService extends CommonService {

  constructor(private router: Router,
    private httpClient: HttpClient,
    configService: AppConfigService,
    private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  public listAllDevices(idHealthUnit: number, idDeviceType: number, assetNumber: string, isOnline: boolean): Observable<ListDeviceResponse> {
    let uri = "DeviceVisualization/getAll?"
    if (idHealthUnit)
      uri = uri + `idHealthUnit=${idHealthUnit}`;

    if (assetNumber)
      uri = uri + `&assetNumber=${assetNumber}`;

    if (isOnline)
      uri = uri + `&isOnline=${isOnline}`;

    if (isOnline)
      uri = uri + `&isOnline=${isOnline}`;

    return this.httpClient.get<ListDeviceResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDevice) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
  public deviceDetails(idDevice: number): Observable<GetDeviceResponse> {
    let uri = `DeviceVisualization/idDevice/${idDevice}`;

    return this.httpClient.get<GetDeviceResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiDevice) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
